import { toast } from 'react-toastify'

/**
 * Displays success toast
 * @param msg message of the toast
 */
export const toastSuccess = (msg: string): void => {
  toast.success(msg, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
  })
}

/**
 * Displays error toast
 * @param msg message of the toast
 */
export const toastError = (msg: string): void => {
  toast.error(msg, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
  })
}

/**
 * Displays toast notifications for a promise (pending, success, error)
 * @param promise The promise to track
 * @param messages Object with pending, success, and error messages
 */
export const toastPromise = <T>(
  promise: Promise<T>,
  messages: { pending: string; success: string; error: string }
): Promise<T> => {
  return toast.promise(
    promise,
    {
      pending: messages.pending,
      success: messages.success,
      error: messages.error,
    },
    {
      position: 'top-right',
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    }
  )
}
